// PKCE utilities: generate code_verifier and code_challenge (S256)

function dec2hex(dec) {
  return (dec < 15.5 ? '0' : '') + Math.round(dec).toString(16)
}

function generateRandomString(length) {
  const array = new Uint32Array(length)
  window.crypto.getRandomValues(array)
  return Array.from(array, dec2hex).join('').slice(0, length)
}

function base64urlencode(arrayBuffer) {
  let str = ''
  const bytes = new Uint8Array(arrayBuffer)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i])
  }
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

async function sha256(plain) {
  const encoder = new TextEncoder()
  const data = encoder.encode(plain)
  return await window.crypto.subtle.digest('SHA-256', data)
}

export async function createPkcePair() {
  const codeVerifier = await generateRandomString(64)
  const digest = await sha256(codeVerifier)
  const codeChallenge = base64urlencode(digest)
  const nonce = await generateRandomString(32)
  const state = await generateRandomString(32)
  sessionStorage.setItem('esignet_code_verifier', codeVerifier);
  sessionStorage.setItem('esignet_code_challenge', codeChallenge);
  sessionStorage.setItem('esignet_nonce', nonce);
  sessionStorage.setItem('esignet_state', state);
  return { codeVerifier, codeChallenge, nonce, state }
}

export function getCodes() {
  const codeVerifier = sessionStorage.getItem('esignet_code_verifier');
  const codeChallenge = sessionStorage.getItem('esignet_code_challenge');
  const nonce = sessionStorage.getItem('esignet_nonce');
  const state = sessionStorage.getItem('esignet_state');
  return { codeVerifier, codeChallenge, nonce, state }
}

export function generateState() {
  return generateRandomString(32)
}
